// ponytail: these mirror VOL_DECLARED_INPUT_EMPTY/FILLED in scenarios_helper.rb;
// keep them in sync if the warning styling changes.
export const VOL_DECLARED_EMPTY = [
  "border-warning-300",
  "bg-warning-50",
  "focus:border-warning-500",
  "focus:ring-warning-500/25",
];
export const VOL_DECLARED_FILLED = [
  "border-gray-modern-300",
  "bg-white",
  "focus:border-brand-600",
  "focus:ring-brand-600/25",
];

export function toggleVolDeclaredEmptyState(input) {
  const value = Number.parseFloat(input.value);
  const empty = !Number.isFinite(value) || value <= 0;

  input.classList.remove(...(empty ? VOL_DECLARED_FILLED : VOL_DECLARED_EMPTY));
  input.classList.add(...(empty ? VOL_DECLARED_EMPTY : VOL_DECLARED_FILLED));
  input.setAttribute("aria-invalid", empty ? "true" : "false");
}

export function calculateVolDeclaredTotal(initialTotal, inputs) {
  const parsedInitialTotal = Number.parseFloat(initialTotal);
  const startingTotal = Number.isFinite(parsedInitialTotal) ? parsedInitialTotal : 0;

  return inputs.reduce((total, input) => {
    const factor = Number.parseFloat(input.factor);
    if (!Number.isFinite(factor)) return total;

    const currentValue = Number.parseFloat(input.currentValue);
    const initialValue = Number.parseFloat(input.initialValue);
    const normalizedCurrentValue = Number.isFinite(currentValue) ? currentValue : 0;
    const normalizedInitialValue = Number.isFinite(initialValue) ? initialValue : 0;

    return total + (normalizedCurrentValue - normalizedInitialValue) * factor;
  }, startingTotal);
}
